var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ServerError)?_c('ServerError'):_vm._e(),_c('v-app',[_c('AppHeader'),_c('router-view'),_c('AppFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }